import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Status } from "../../routes/doa-forecast/DoaForecastModels";
import { getKeyByValue } from '../../utils';

export interface IInfoBoxProps {
  date: string;
  dispatchDescription: string;
  dispatch?: string;
  availabilityStatus: Status,
  dispatchStatus: Status,
  onClick?: (dispatch: string, date: string) => void,
}

export const InfoBox: React.FC<IInfoBoxProps> = ({
  date,
  dispatch,
  availabilityStatus,
  dispatchStatus,
  dispatchDescription,
  onClick
}) => (
  <Table size="custom" className="info-box">
    <TableHead>
      <TableRow>
        <TableCell colSpan={2}>
          <Box sx={{ pb: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography data-automation="dispatch-date-shift">{date} - {dispatchDescription}</Typography>
          </Box>
          <Typography data-automation="availability-label" className='subheader'>
            Availability Status:
            <Typography data-automation="availability-status" component='span' className={`${getKeyByValue(Status, availabilityStatus)} subheader`}> {availabilityStatus}</Typography>
          </Typography>
          <Typography data-automation="physical-dispatch-label" className='subheader'>
            Physical Dispatch Status:
            <Typography data-automation="physical-dispatch-status" component='span' className={`${getKeyByValue(Status, dispatchStatus)} subheader`}> {dispatchStatus}</Typography>
          </Typography>
        </TableCell>
      </TableRow>
    </TableHead>
    {onClick && dispatch && <TableBody>
      <TableRow>
        <TableCell colSpan={2}>
          <Button
            variant="contained"
            size="medium"
            onClick={() => onClick(dispatch, date)}
            data-automation="doa-avail-btn"
          >
            Declaration of Availability
          </Button>
        </TableCell>
      </TableRow>
    </TableBody>}
  </Table>
)